import Popover from "@idui/react-popover";
import styled, { css } from "styled-components";

import { PNG } from "@ryde/assets";
import { normalizeCssSize, type IStyledAttributes } from "@ryde/shared";
import { blueGreyMui, greyMui, rydeColors } from "@ryde/theme";

export const HeaderCelSortablePopover = styled(
  Popover,
).attrs<IStyledAttributes>({
  "data-e2e": "header-cell-sortable-popover",
})`
  background-color: ${rydeColors.white};
  border-radius: 8px;
  border: 2px solid ${greyMui._700};
`;

export const HeaderCellSortableButtonWrapper = styled.span.attrs<IStyledAttributes>(
  {
    "data-e2e": "header-cell-button-wrapper",
  },
)`
  .header_sortable_button {
    border: none;
    font-weight: inherit;
    color: inherit;
    font-family: inherit;
    font-size: inherit;
    background-color: inherit;
    display: flex;
    align-items: center;
    justify-content: stretch;
    width: 100%;
    line-height: 12px;
    height: 18px;
    cursor: pointer;

    .th_sortable_popover-wrapper {
      display: flex;
      align-items: center;
      width: 100%;
    }

    span.th_sortable_content {
      display: flex;
      align-items: center;
      height: 12px;
    }
    span.th_sortable_text_wrapper {
      display: inline-block;
      vertical-align: middle;
      line-height: normal;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      text-align: start;
      width: auto;
    }
    svg {
      fill: ${blueGreyMui._500};
      min-width: 10px;
      max-width: 10px;
      margin-inline-start: 2px;
    }
    & > span {
      display: block !important;
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  &.is_hidden {
    display: none;
  }
`;

export const LastHeadCellStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "last-head-cell",
})`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  button {
    border: none;
    cursor: pointer;
  }
  svg {
    width: 15px;
    height: 15px;
  }
`;

export const TableHeaderCellStyled = styled.th.attrs<IStyledAttributes>({
  "data-e2e": "table-header-cell",
})<{ $columnWidth?: string | number }>`
  position: relative;
  padding: 6px;
  font-weight: 500;
  font-size: 12px;
  text-align: left;
  color: ${blueGreyMui._500};
  border-top: 1px solid ${greyMui._300};
  div.th_content {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    min-height: 18px;
  }

  ${({ $columnWidth }) =>
    $columnWidth &&
    css`
      width: ${normalizeCssSize($columnWidth)};
    `}
  &:first-child:not(.custom_left_line_head) {
    border-start-start-radius: 3px;
    background: url(${PNG.TableLeftBgMuiPNG}) repeat-y;
  }
  &:first-child.custom_left_line_head {
    border-start-start-radius: 3px;
  }
  &:last-child {
    border-start-end-radius: 3px;
  }
`;
